var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2ac61fe8553c201dddb8d2d02abebd1fab318c03"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["timeneye-frontend@timeneye"]={id:"2ac61fe8553c201dddb8d2d02abebd1fab318c03"};
      